import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { TipuriDocumenteService } from '../tipuri-documente.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { TipDocumente } from '../tipuri-documente.interface';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-add-tipuri-documente',
    templateUrl: './add-tipuri-documente.component.html',
    styleUrls: ['./add-tipuri-documente.component.scss']
})
export class AddTipuriDocumenteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        archive_auto_days: new FormControl(null),
    });

    constructor(
        private dialogRef: MatDialogRef<AddTipuriDocumenteComponent>,
        private tipuriDocumenteService: TipuriDocumenteService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.tipuriDocumenteService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, archive_auto_days } = this.form
            .value as TipDocumente;

        const newTip: TipDocumente = {
            name,
            slug,
            archive_auto_days,
        };

        this.tipuriDocumenteService
            .addTipDocument(newTip)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
